import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useModal } from '@app/context/ModalsContext'

import { AuthSessionContext } from '@context/AuthContext'

import { getDateTimeFormat } from '@ui/v2/Table/cells/DateTime'
import { useTableColumns } from '@ui/v2/Table/hooks/useTableRows'
import { TableViewMoreModal } from '@ui/v2/Table/modals/TableViewMore.modal'
import { BaseColumnCtx } from '@ui/v2/Table/types'

import { ClientJourneyMapDto } from '@model/ClientJourneyMap'

import { useFormatNumber } from '@hooks/useFormatNumber'

import { IAppendableFetchQueryResult, SearchResponseProps } from '../IBReportResultsPage'
import { IBReportsTable } from '../IBReportsTable'
import { CJMColumn, cjmColumns } from './IBClientJourneyMapTable.columns'

export type IBClientJourneyMapSortKeys =
  | 'Name'
  | 'LinkClickedDate'
  | 'RegistrationDate'
  | 'EmailVerifiedDate'
  | 'ActivatedDate'
  | 'FirstCompletedDepositDate'
  | 'FirstClosedTradeDate'
  | 'LastClosedTradeDate'
  | 'TotalCommission'

interface Props {
  data: IAppendableFetchQueryResult<ClientJourneyMapDto>
  search: SearchResponseProps
}

export const IBClientJourneyMapTable: React.FC<Props> = (props) => {
  const { data: ibAccountSummary, search } = props

  const [auth] = useContext(AuthSessionContext)
  const rawDateFormat = auth?.dateFormatType?.name
  const dateFormat = getDateTimeFormat(rawDateFormat)
  const { formatMoney } = useFormatNumber()
  const { t } = useTranslation()

  const cjmViewMoreModal = useModal(TableViewMoreModal<ClientJourneyMapDto>)

  const data = ibAccountSummary.query.data ?? []
  const colsFormatCtx: BaseColumnCtx = { t, formatMoney, dateFormat }

  const { renderColumns } = useTableColumns<ClientJourneyMapDto, BaseColumnCtx, CJMColumn>({
    columns: cjmColumns,
    formatCtx: colsFormatCtx,
    onArrowClick: (_, index) =>
      cjmViewMoreModal.open({
        data,
        initialIndex: index,
        formatCtx: colsFormatCtx,
        columns: cjmColumns,
      }),
  })

  return (
    <IBReportsTable
      tableQuery={ibAccountSummary.query}
      sortOptions={search.sortOptions}
      renderColumns={renderColumns}
    />
  )
}
